export const DEFAULT_TITLE_PREFIX = 'Ideal4Finance';
export const DEFAULT_SEPARATOR = '|';
